declare global {
  interface Window {
    readonly __hubnariPrivateLanding?: boolean;
    __hubnariConsumeAuthLink?: (
      kind: 'reset' | 'invitation',
    ) => { email: string | null; value: string | null } | null;
  }
}

export function isPrivateAuthLanding(): boolean {
  return window.__hubnariPrivateLanding === true;
}

export function consumeAuthLink(
  kind: 'reset' | 'invitation',
): { email: string | null; value: string | null } | null {
  return window.__hubnariConsumeAuthLink?.(kind) ?? null;
}
